import { Action } from '../actions';
import {
    CLEAR_IMAGE_SMART_CENTER_EDITOR,
    FILL_IMAGE_SMART_CENTER_EDITOR_DATA,
    FIX_SMART_CENTER_IMAGE_HEIGHT,
    SAVE_IMAGE_SMART_CENTER,
    SET_IMAGE_SMART_CENTER_EDITOR_ERROR,
    SET_IMAGE_SMART_CENTER_POS,
    SET_SELECTED_IMAGE_SMART_CENTER_RATIO
} from '../actions/imageSmartCenterEditor';
import { PageStatus } from '../typings/common';
import { ImageSmartCenterEditorState } from '../typings/imageSmartCenterEditor';

export function imageSmartCenterEditor(
    state: ImageSmartCenterEditorState = {},
    action: Action
): ImageSmartCenterEditorState {
    switch (action.type) {
        case FILL_IMAGE_SMART_CENTER_EDITOR_DATA:
            return {
                data: action.payload
            };

        case SET_SELECTED_IMAGE_SMART_CENTER_RATIO:
            if (!state.data) {
                return state;
            }
            return {
                data: { ...state.data, selectedId: action.selectedId }
            };

        case SET_IMAGE_SMART_CENTER_POS:
            if (!state.data) {
                return state;
            }
            return {
                data: {
                    ...state.data,
                    centers: {
                        ...state.data.centers,
                        [state.data.selectedId]: {
                            ...state.data.centers[state.data.selectedId],
                            pos: {
                                x: action.x,
                                y: action.y
                            }
                        }
                    }
                }
            };

        case SET_IMAGE_SMART_CENTER_EDITOR_ERROR:
            if (!state.data) {
                return state;
            }
            return {
                data: {
                    ...state.data,
                    error: action.error,
                    status: PageStatus.ERROR
                }
            };

        case CLEAR_IMAGE_SMART_CENTER_EDITOR:
            return {
                imageHeight: state.imageHeight,
                imageUrl: state.imageUrl
            };

        case FIX_SMART_CENTER_IMAGE_HEIGHT:
            if (action.imageUrl === state.imageUrl) {
                return state;
            }

            return {
                ...state,
                imageHeight: action.imageHeight,
                imageUrl: action.imageUrl
            };

        case SAVE_IMAGE_SMART_CENTER:
            if (!state.data) {
                return state;
            }

            return {
                ...state,
                data: {
                    ...state.data,
                    status: PageStatus.SAVING
                }
            };

        default:
            return state;
    }
}
